module.exports = __webpack_public_path__ + "images/ascending-c9652f64.svg";